import type { MessageKey } from "./ru"

export const itMessages = {
  "common.loading": "Caricamento...",
  "common.error": "Errore",
  "common.back": "Indietro",
  "common.next": "Avanti",
  "common.search": "Cerca",
  "auth.loginErrorTitle": "Errore di accesso",
  "auth.openViaTelegram": "Apri l'app tramite Telegram",
  "auth.telegramRequired": "L'app deve essere aperta tramite Telegram",
  "auth.authorizationError": "Errore di autorizzazione",
  "device.rotatePortrait": "Ruota il dispositivo in verticale",
  "country.brazil": "Brasile",
  "country.vietnam": "Vietnam",
  "country.egypt": "Egitto",
  "country.india": "India",
  "country.indonesia": "Indonesia",
  "country.iran": "Iran",
  "country.spain": "Spagna",
  "country.italy": "Italia",
  "country.kazakhstan": "Kazakistan",
  "country.colombia": "Colombia",
  "country.malaysia": "Malesia",
  "country.mexico": "Messico",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Russia",
  "country.usa": "Stati Uniti",
  "country.turkey": "Turchia",
  "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ucraina",
  "country.philippines": "Filippine",
  "countrySelection.chooseCountry": "Scegli un paese",
  "countrySelection.openAria": "Scegli paese",
  "languageSelection.chooseLanguage": "Scegli una lingua",
  "commercial.direction.autotrade": "Auto Mercato",
  "commercial.direction.insurance": "Assicurazione",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Assistenza stradale",
  "commercial.searchLabel": "Ricerca BeepApp",
  "commercial.cityPlaceholder": "Inserisci la città",
  "commercial.emptyTitle": "Nessuna offerta oggi",
  "commercial.emptyLine1": "Non ci sono ancora partner BeepApp attivi nella tua città",
  "commercial.emptyLine2": "Stiamo già lavorando per trovarli e collegarli",
  "commercial.emptyLine3": "Le nuove offerte appariranno qui automaticamente",
  "commercial.helperLine1": "Indica la tua città per vedere",
  "commercial.helperLine2": "le offerte disponibili",
  "commercial.partnerPrompt": "Vuoi diventare partner BeepApp?",
  "commercial.apply": "Invia richiesta",
  "main.admin": "Admin",
  "main.garage": "Garage",
  "main.signalSent": "Segnale inviato",
  "main.partnerInviteUnavailable": "Invito partner non disponibile",
  "main.enterPlate": "Inserisci la targa",
  "main.searchError": "Errore di ricerca",
  "main.signalSendError": "Invio del segnale non riuscito",
  "main.shareCardPrefix": "Scheda targa",
  "main.shareLinkError": "Impossibile preparare il link",
  "main.searchByPlateAria": "Cerca per targa",
  "main.russianPlateAria": "Targa russa",
  "main.plateAria": "Targa",
  "main.findPlateAria": "Trova targa",
  "main.loadingVehicle": "Caricamento scheda targa…",
  "main.leaveSignal": "Invia un segnale",
  "main.share": "Condividi",
  "signalSelection.chooseType": "Scegli il tipo di segnale",
  "signalSelection.category.attention": "Personali",
  "signalSelection.category.road": "Stradali",
  "signalSelection.category.urgent": "Urgenti",
  "signalSelection.chooseSignal": "Scegli un segnale",
  "signalSelection.suggestOwn": "Proponi la tua opzione",
  "signalConfirmation.title": "Conferma segnale",
  "signalConfirmation.plateHeading": "Controlla la targa del veicolo",
  "signalConfirmation.signalHeading": "Controlla il segnale selezionato",
  "signalConfirmation.replyTitle": "Consenti risposta su Telegram",
  "signalConfirmation.replyBody": "Attiva questa funzione per permettere al proprietario della targa di\nscriverti su Telegram. La risposta è possibile solo se\nhai un @username. La decisione di rispondere resta\nal proprietario della targa.",
  "signalConfirmation.consentText": "Confermo che questo segnale corrisponde\na una situazione reale e non è spam\nné una segnalazione falsa.",
  "signalConfirmation.warning": "Dopo l'invio il segnale\nnon potrà essere modificato",
  "signalConfirmation.sending": "Invio…",
  "signalConfirmation.send": "Invia",
  "partner.loadingAria": "Caricamento",
  "partner.title": "Programma partner",
  "partner.offerLine1": "Ricevi il 30% di tutti i pagamenti senza scadenza",
  "partner.offerLine2": "effettuati dagli utenti invitati su BeepApp",
  "partner.offerLine3": "tramite il programma affiliati di Telegram",
  "partner.connectUnavailable": "La connessione sarà disponibile dopo la configurazione del programma affiliati Telegram.",
  "partner.connectTelegram": "Connetti in Telegram",
  "partner.qrAria": "Codice QR del link partner",
  "partner.download": "Scarica",
  "partner.promoHeading": "Crea un codice promozionale personale",
  "partner.promoHelperLine1": "Il codice promozionale attiva un anno extra di abbonamento",
  "partner.promoHelperLine2": "e aiuta ad attirare utenti",
  "partner.promoAria": "Codice promozionale",
  "partner.affiliateHeading": "Il tuo link affiliato",
  "partner.affiliateHelper": "Salva il link per creare un codice QR personale",
  "partner.affiliateAria": "Link affiliato",
  "partner.qrNoteLine1": "Il codice QR può essere posizionato sul veicolo,",
  "partner.qrNoteLine2": "sui social network e nei materiali pubblicitari",
  "partner.save": "Salva",
  "partner.reset": "Reimposta",
  "partner.resetConfirm": "Reimpostare il link affiliato salvato? Il codice promozionale resterà tuo.",
  "partner.promoFormatError": "Il codice promozionale deve contenere da 4 a 15 caratteri.",
  "partner.affiliateHostError": "Sono consentiti solo link t.me o telegram.me.",
  "partner.affiliatePathError": "Il link non contiene un percorso Telegram.",
  "partner.affiliateFormatError": "Link affiliato non valido.",
  "partner.loadError": "Errore di caricamento",
  "partner.checkInputError": "Controlla i dati inseriti",
  "garageActivation.promoInvalid": "Codice promozionale non valido",
  "garageActivation.plateOccupied": "Questa targa è già collegata",
  "garageActivation.activateError": "Impossibile attivare il Garage",
  "garageEntry.loadJournalError": "Impossibile caricare il registro",
  "garageEntry.loadStatusesError": "Impossibile caricare gli stati",
  "garageEntry.activationSuccess": "Garage attivato con successo",
  "garageEntry.plateAttached": "Targa collegata",
  "garageEntry.attachError": "Impossibile collegare la targa",
  "garageEntry.activationNote": "Attiva il tuo Garage",
  "garageSheet.activationTitle": "Attivazione Garage",
  "garageSheet.plateHelper": "Inserisci la targa del veicolo",
  "garageSheet.promoHelper": "Hai un codice promozionale?",
  "garageSheet.cleanBonusLine1": "Dopo l'attivazione avrai 1 ora",
  "garageSheet.cleanBonusLine2": "per un “Nuovo Inizio” gratuito",
  "garageSheet.activationFor": "Attivazione per",
  "garageSheet.cost": "Costo",
  "garageSheet.ownerConsentLine1": "Confermo di essere il proprietario",
  "garageSheet.ownerConsentLine2": "del veicolo con la targa",
  "garageSheet.ownerConsentLine3": "specificata.",
  "garageSheet.processing": "Elaborazione...",
  "garageSheet.attach": "Collega",
  "garageSheet.pay": "Paga",
  "garageLifecycle.cleanTitle": "Nuovo Inizio",
  "garageLifecycle.deactivateTitle": "Disattivazione Garage",
  "garageLifecycle.cleanWarningLine1": "La cronologia della targa sarà eliminata",
  "garageLifecycle.cleanWarningLine2": "senza possibilità di recupero!",
  "garageLifecycle.deactivateWarningLine1": "Dopo la disattivazione, l'accesso alle funzioni",
  "garageLifecycle.deactivateWarningLine2": "del Garage attivo verrà interrotto",
  "garageLifecycle.willBeDeleted": "SARÀ ELIMINATO",
  "garageLifecycle.cleanRemovedLine1": "• Tutte le voci del Registro di Bordo",
  "garageLifecycle.cleanRemovedLine2": "• Cronologia dei segnali ricevuti",
  "garageLifecycle.cleanRemovedLine3": "• Contatori pubblici dei segnali",
  "garageLifecycle.cleanRemovedLine4": "  sulla scheda della targa",
  "garageLifecycle.willRemain": "RIMARRÀ",
  "garageLifecycle.cleanPreservedLine1": "• Collegamento della targa al Garage",
  "garageLifecycle.cleanPreservedLine2": "• Periodo di attivazione rimanente",
  "garageLifecycle.cleanPreservedLine3": "• Stato della targa selezionato",
  "garageLifecycle.cleanPreservedLine4": "• Numero totale di visualizzazioni della scheda",
  "garageLifecycle.freeFirstHour": "Gratis durante la prima ora",
  "garageLifecycle.willBecomeUnavailable": "DIVENTERÀ NON DISPONIBILE",
  "garageLifecycle.deactivateRemovedLine1": "• Registro di Bordo",
  "garageLifecycle.deactivateRemovedLine2": "• Selezione e uso dello stato della targa",
  "garageLifecycle.deactivateRemovedLine3": "• Uscirai automaticamente dall'AutoClan",
  "garageLifecycle.deactivateRemovedLine4": "• Auto Mercato",
  "garageLifecycle.deactivateRemovedLine5": "• Assicurazione",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Assistenza stradale",
  "garageLifecycle.deactivateRemovedLine8": "• La targa verrà scollegata dal Garage",
  "garageLifecycle.willRemainAvailable": "RIMARRANNO DISPONIBILI",
  "garageLifecycle.deactivatePreservedLine1": "• Compagno",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• Ricerca per targa e visualizzazione",
  "garageLifecycle.deactivatePreservedLine4": "  della scheda pubblica del veicolo",
  "garageLifecycle.deactivatePreservedLine5": "• Possibilità di riattivare",
  "garageLifecycle.deactivatePreservedLine6": "  il Garage in qualsiasi momento",
  "garageLifecycle.cleanConsentLine1": "Confermo il consenso all'eliminazione",
  "garageLifecycle.cleanConsentLine2": "dell'intera cronologia di questa targa",
  "garageLifecycle.cleanConsentLine3": "senza possibilità di recupero.",
  "garageLifecycle.deactivateConsentLine1": "Confermo la disattivazione e",
  "garageLifecycle.deactivateConsentLine2": "la cessazione dell'accesso a tutte",
  "garageLifecycle.deactivateConsentLine3": "le funzioni del Garage attivo.",
  "garageLifecycle.clean": "Pulisci",
  "garageLifecycle.deactivate": "Disattiva",
} satisfies Record<MessageKey, string>
